import { render } from "./DocRegView.vue?vue&type=template&id=445f9ff2"
import script from "./DocRegView.vue?vue&type=script&lang=js"
export * from "./DocRegView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__